var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiStrategy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9369 27.5C21.8477 27.1539 21.6673 26.8381 21.4146 26.5854C21.1618 26.3327 20.846 26.1523 20.4999 26.063L14.3649 24.481C14.2603 24.4513 14.1681 24.3883 14.1026 24.3014C14.037 24.2146 14.0015 24.1088 14.0015 24C14.0015 23.8912 14.037 23.7854 14.1026 23.6986C14.1681 23.6118 14.2603 23.5487 14.3649 23.519L20.4999 21.936C20.8459 21.8468 21.1616 21.6666 21.4143 21.414C21.6671 21.1615 21.8475 20.8459 21.9369 20.5L23.5189 14.365C23.5483 14.2599 23.6113 14.1673 23.6983 14.1014C23.7852 14.0355 23.8913 13.9998 24.0004 13.9998C24.1096 13.9998 24.2157 14.0355 24.3026 14.1014C24.3896 14.1673 24.4525 14.2599 24.4819 14.365L26.0629 20.5C26.1522 20.8461 26.3326 21.1619 26.5853 21.4146C26.838 21.6673 27.1539 21.8477 27.4999 21.937L33.6349 23.518C33.7404 23.5471 33.8335 23.61 33.8998 23.6971C33.9661 23.7841 34.002 23.8906 34.002 24C34.002 24.1094 33.9661 24.2159 33.8998 24.3029C33.8335 24.39 33.7404 24.4529 33.6349 24.482L27.4999 26.063C27.1539 26.1523 26.838 26.3327 26.5853 26.5854C26.3326 26.8381 26.1522 27.1539 26.0629 27.5L24.4809 33.635C24.4515 33.7401 24.3886 33.8327 24.3016 33.8986C24.2147 33.9646 24.1086 34.0003 23.9994 34.0003C23.8903 34.0003 23.7842 33.9646 23.6973 33.8986C23.6103 33.8327 23.5473 33.7401 23.5179 33.635L21.9369 27.5Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15V19",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17H30",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29V31",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 30H15",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStrategy);
export default __webpack_public_path__ + "static/media/AIStrategy.7c156063557a39bec2fa677c34641345.svg";
export { ForwardRef as ReactComponent };